import { Text } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils';

import type { TypeReceiveStatusDetailItem } from '~/types/receive.types';

import styles from './ReceiveStatusQtyDetailCell.module.scss';

/**
 * [입고관리 > 입고현황] 입고 현황 상세 모달 내 수량 셀. 정상 수량은 초록, 문제 수량은 빨강으로 보인다. 수량상세가 없으면 '-'.
 */
const ReceiveStatusQtyDetailCell = ({ detail }: { detail: TypeReceiveStatusDetailItem['details'][number] | null }) => {
  if (!detail) return <>-</>;

  const isPassed = detail.isPassed;

  return (
    <Text className={styles['qty-value']} size="large" color={isPassed ? 'success' : 'error'}>
      {detail.qty > 0 ? formatNumber(detail.qty) : '-'}
    </Text>
  );
};

export default ReceiveStatusQtyDetailCell;
